import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { SignJWT } from 'jose';
import './OnboardingWizard.css';

const AVATARS = [
  {
    id: 1,
    image: 'https://cdn.lovescape.com/cdn/front/images/marketing/afrogingercaucasian.webp',
    json: {
      imageStyle: 'realistic',
      gender: 'female',
      safetyLevel: 'nude',
      age: 25,
      extraFields: {
        Etnicity: 'ebony',
        hairColor: 'ginger',
        hairStyle: 'afro',
        eyeColor: 'green',
        skinTone: 'fair',
        height: '170 cm',
        bodyType: 'slim'
      }
    }
  },
  {
    id: 2,
    image: 'https://cdn.lovescape.com/cdn/front/images/marketing/asianblack.webp',
    json: {
      imageStyle: 'realistic',
      gender: 'female',
      safetyLevel: 'nude',
      age: 25,
      extraFields: {
        Etnicity: 'asian',
        hairColor: 'brown',
        hairStyle: 'straight',
        eyeColor: 'green',
        skinTone: 'fair',
        height: '170 cm',
        bodyType: 'slim'
      }
    }
  },
  {
    id: 3,
    image: 'https://cdn.lovescape.com/cdn/front/images/marketing/blondcaucasian.webp',
    json: {
      imageStyle: 'realistic',
      gender: 'female',
      safetyLevel: 'nude',
      age: 25,
      extraFields: {
        Etnicity: 'caucasian',
        hairColor: 'white',
        hairStyle: 'straight',
        eyeColor: 'green',
        skinTone: 'fair',
        height: '170 cm',
        bodyType: 'slim'
      }
    }
  },
  {
    id: 4,
    image: 'https://cdn.lovescape.com/cdn/front/images/marketing/bluecaucasian.webp',
    json: {
      imageStyle: 'realistic',
      gender: 'female',
      safetyLevel: 'nude',
      age: 25,
      extraFields: {
        Etnicity: 'caucasian',
        hairColor: 'blue',
        hairStyle: 'straight',
        eyeColor: 'green',
        skinTone: 'fair',
        height: '170 cm',
        bodyType: 'slim'
      }
    }
  },
  {
    id: 5,
    image: 'https://cdn.lovescape.com/cdn/front/images/marketing/browncaucasian.webp',
    json: {
      imageStyle: 'realistic',
      gender: 'female',
      safetyLevel: 'nude',
      age: 25,
      extraFields: {
        Etnicity: 'caucasian',
        hairColor: 'brown',
        hairStyle: 'straight',
        eyeColor: 'green',
        skinTone: 'fair',
        height: '170 cm',
        bodyType: 'slim'
      }
    }
  },
  {
    id: 6,
    image: 'https://cdn.lovescape.com/cdn/front/images/marketing/colorafro.webp',
    json: {
      imageStyle: 'realistic',
      gender: 'female',
      safetyLevel: 'nude',
      age: 25,
      extraFields: {
        Etnicity: 'ebony',
        hairColor: 'black-pink',
        hairStyle: 'small braids',
        eyeColor: 'brown',
        skinTone: 'fair',
        height: '170 cm',
        bodyType: 'slim'
      }
    }
  },
  {
    id: 7,
    image: 'https://cdn.lovescape.com/cdn/front/images/marketing/colorarab.webp',
    json: {
      imageStyle: 'realistic',
      gender: 'female',
      safetyLevel: 'nude',
      age: 25,
      extraFields: {
        Etnicity: 'arab',
        hairColor: 'purpule-pink',
        hairStyle: 'waivy',
        eyeColor: 'brown',
        skinTone: 'fair',
        height: '170 cm',
        bodyType: 'slim'
      }
    }
  },
  {
    id: 8,
    image: 'https://cdn.lovescape.com/cdn/front/images/marketing/curlycurvyblack.webp',
    json: {
      imageStyle: 'realistic',
      gender: 'female',
      safetyLevel: 'nude',
      age: 25,
      extraFields: {
        Etnicity: 'ebony',
        hairColor: 'black-yellow',
        hairStyle: 'afro',
        eyeColor: 'brown',
        skinTone: 'fair',
        height: '170 cm',
        bodyType: 'curvy'
      }
    }
  },
  {
    id: 9,
    image: 'https://cdn.lovescape.com/cdn/front/images/marketing/gingercoucasian.webp',
    json: {
      imageStyle: 'realistic',
      gender: 'female',
      safetyLevel: 'nude',
      age: 25,
      extraFields: {
        Etnicity: 'caucasian',
        hairColor: 'ginger',
        hairStyle: 'smal waves',
        eyeColor: 'brown',
        skinTone: 'fair',
        height: '170 cm',
        bodyType: 'slim'
      }
    }
  },
  {
    id: 10,
    image: 'https://cdn.lovescape.com/cdn/front/images/marketing/greenindian.webp',
    json: {
      imageStyle: 'realistic',
      gender: 'female',
      safetyLevel: 'nude',
      age: 25,
      extraFields: {
        Etnicity: 'indian',
        hairColor: 'green',
        hairStyle: 'straight',
        eyeColor: 'brown',
        skinTone: 'fair',
        height: '170 cm',
        bodyType: 'slim'
      }
    }
  },
  {
    id: 11,
    image: 'https://cdn.lovescape.com/cdn/front/images/marketing/greenslim.webp',
    json: {
      imageStyle: 'realistic',
      gender: 'female',
      safetyLevel: 'nude',
      age: 25,
      extraFields: {
        Etnicity: 'caucasian',
        hairColor: 'green',
        hairStyle: 'ponytail',
        eyeColor: 'brown',
        skinTone: 'fair',
        height: '170 cm',
        bodyType: 'slim'
      }
    }
  },
  {
    id: 12,
    image: 'https://cdn.lovescape.com/cdn/front/images/marketing/indianbrown.webp',
    json: {
      imageStyle: 'realistic',
      gender: 'female',
      safetyLevel: 'nude',
      age: 25,
      extraFields: {
        Etnicity: 'indian',
        hairColor: 'black',
        hairStyle: 'straigt',
        eyeColor: 'brown',
        skinTone: 'fair',
        height: '170 cm',
        bodyType: 'slim'
      }
    }
  },
  {
    id: 13,
    image: 'https://cdn.lovescape.com/cdn/front/images/marketing/whitecaucasian.webp',
    json: {
      imageStyle: 'realistic',
      gender: 'female',
      safetyLevel: 'nude',
      age: 25,
      extraFields: {
        Etnicity: 'ebony',
        hairColor: 'white',
        hairStyle: 'straight',
        eyeColor: 'blue',
        skinTone: 'fair',
        height: '170 cm',
        bodyType: 'smlim'
      }
    }
  },
  {
    id: 14,
    image: 'https://cdn.lovescape.com/cdn/front/images/marketing/whitecurvy.webp',
    json: {
      imageStyle: 'realistic',
      gender: 'female',
      safetyLevel: 'nude',
      age: 65,
      extraFields: {
        Etnicity: 'caucasian',
        hairColor: 'white',
        hairStyle: 'short',
        eyeColor: 'brown',
        skinTone: 'fair',
        height: '170 cm',
        bodyType: 'curvy'
      }
    }
  },
  {
    id: 15,
    image: 'https://cdn.lovescape.com/cdn/front/images/marketing/yellowbobslim.webp',
    json: {
      imageStyle: 'realistic',
      gender: 'female',
      safetyLevel: 'nude',
      age: 25,
      extraFields: {
        Etnicity: 'caucasian',
        hairColor: 'yellow',
        hairStyle: 'bob',
        eyeColor: 'brown',
        skinTone: 'fair',
        height: '170 cm',
        bodyType: 'slim'
      }
    }
  }
];

const PERSONALITY_TRAITS = [
  { left: 'Shy', right: 'Flirty' },
  { left: 'Pessimistic', right: 'Optimistic' },
  { left: 'Ordinary', right: 'Mysterious' }
];

const GOALS = [
  'Roleplay',
  'Chat about random stuff',
  'Feel less lonely',
  'Make a virtual friend',
  'Have fun',
  'Play chat games',
  'Share emotions',
  'Talk shame-free',
  'Other'
];

const PASSIONS = [
  { text: 'dogs', emoji: '🐕' },
  { text: 'fashion', emoji: '👗' },
  { text: 'board games', emoji: '🎲' },
  { text: 'cats', emoji: '🐱' },
  { text: 'instagram', emoji: '📸' },
  { text: 'tea', emoji: '🍵' },
  { text: 'travel', emoji: '✈️' },
  { text: 'running', emoji: '🏃' },
  { text: 'cooking', emoji: '🍳' },
  { text: 'beer', emoji: '🍺' },
  { text: 'working out', emoji: '💪' },
  { text: 'gardening', emoji: '🌱' },
  { text: 'hiking', emoji: '🥾' },
  { text: 'astrology', emoji: '⭐' },
  { text: 'fishing', emoji: '🎣' },
  { text: 'wine', emoji: '🍷' },
  { text: 'sports', emoji: '⚽' },
  { text: 'shopping', emoji: '🛍️' },
  { text: 'netflix', emoji: '📺' },
  { text: 'art', emoji: '🎨' },
  { text: 'swimming', emoji: '🏊' },
  { text: 'dancing', emoji: '💃' },
  { text: 'photography', emoji: '📷' },
  { text: 'politics', emoji: '🗳️' },
  { text: 'music', emoji: '🎵' },
  { text: 'outdoors', emoji: '🏕️' },
  { text: 'writing', emoji: '✍️' },
  { text: 'karaoke', emoji: '🎤' },
  { text: 'videogames', emoji: '🎮' },
  { text: 'coffee', emoji: '☕' }
];

const OnboardingWizard = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const [selectedAvatar, setSelectedAvatar] = useState(AVATARS[0]);
  const [generatedJWT, setGeneratedJWT] = useState(null);
  const [personalities, setPersonalities] = useState([50, 50, 50]);
  const [selectedGoals, setSelectedGoals] = useState([]);
  const [selectedPassions, setSelectedPassions] = useState([]);

  const SECRET_KEY = '2u0O4I&>m|n|5P"Nwvi0SlimSteam#';

  const generateJWT = async (payload) => {
    try {
      const secret = new TextEncoder().encode(SECRET_KEY);
      const jwt = await new SignJWT(payload)
        .setProtectedHeader({ alg: 'HS256' })
        .sign(secret);
      return jwt;
    } catch (error) {
      console.error('JWT generation error:', error);
      return null;
    }
  };

  const handleNext = async () => {
    if (currentStep === 2) {
      // Generate JWT from selected avatar
      const jwt = await generateJWT(selectedAvatar.json);
      setGeneratedJWT(jwt);
    }

    if (currentStep < 6) {
      setCurrentStep(currentStep + 1);
    }

    if (currentStep === 6) {
      // Redirect to lovescape with new parameters
      const redirectUrl = `https://lovescape.com/character-pro/avatar/${generatedJWT}?userId=c2f1936c0214a49d58880b116c336124034d7a2a06705b627765a7c90f586a25&campaignId=coomer`;
      window.location.href = redirectUrl;
    }
  };

  const handleAvatarSelect = (avatar) => {
    setSelectedAvatar(avatar);
  };

  const toggleGoal = (goal) => {
    setSelectedGoals(prev => 
      prev.includes(goal) ? prev.filter(g => g !== goal) : [...prev, goal]
    );
  };

  const togglePassion = (passion) => {
    setSelectedPassions(prev => 
      prev.includes(passion) ? prev.filter(p => p !== passion) : [...prev, passion]
    );
  };

  useEffect(() => {
    if (currentStep === 6) {
      setTimeout(() => {
        handleNext();
      }, 3000);
    }
  }, [currentStep]);

  return (
    <div className="onboarding-container">
      <div className="animated-background"></div>
      
      {/* Background avatar for steps 3-6 */}
      {(currentStep >= 3 && currentStep <= 6) && (
        <div className="background-avatar" style={{ backgroundImage: `url(${selectedAvatar.image})` }}></div>
      )}
      
      <div className="content-wrapper">
        {/* Page 1: Landing - Smaller image with title below */}
        {currentStep === 1 && (
          <div className="step-container-fullscreen fade-in">
            <div className="hero-simple-container">
              <img 
                src="https://cdn.lovescape.com/cdn/front/images/marketing/Photoroom.webp" 
                alt="AI Girlfriend" 
                className="hero-image-simple"
              />
              <h1 className="hero-title-simple">Your Personal AI Girlfriend</h1>
              <button className="primary-button" onClick={handleNext}>
                Continue
              </button>
            </div>
          </div>
        )}

        {/* Page 2: Avatar Selection - Fullscreen image with carousel */}
        {currentStep === 2 && (
          <div className="step-container-fullscreen fade-in">
            <div className="avatar-selection-container">
              <h2 className="step-title-page2">Choose her appearance.</h2>
              
              <div className="avatar-display-wrapper">
                <img 
                  src={selectedAvatar.image} 
                  alt="Selected Avatar" 
                  className="avatar-fullscreen-image"
                />
              </div>

              <div className="avatar-carousel-wrapper">
                <div className="avatar-carousel">
                  {AVATARS.map(avatar => (
                    <div 
                      key={avatar.id}
                      className={`avatar-thumbnail ${selectedAvatar.id === avatar.id ? 'selected' : ''}`}
                      onClick={() => handleAvatarSelect(avatar)}
                    >
                      <img src={avatar.image} alt={`Avatar ${avatar.id}`} />
                    </div>
                  ))}
                </div>
              </div>

              <button className="primary-button" onClick={handleNext}>
                Continue
              </button>
            </div>
          </div>
        )}

        {/* Page 3: Personality */}
        {currentStep === 3 && (
          <div className="step-container fade-in with-bg-avatar">
            <div className="content-overlay">
              <h2 className="step-title">Tweak personality</h2>
              
              <div className="personality-sliders">
                {PERSONALITY_TRAITS.map((trait, index) => (
                  <div key={index} className="slider-container">
                    <div className="slider-labels">
                      <span>{trait.left}</span>
                      <span>{trait.right}</span>
                    </div>
                    <input 
                      type="range" 
                      min="0" 
                      max="100" 
                      value={personalities[index]}
                      onChange={(e) => {
                        const newPersonalities = [...personalities];
                        newPersonalities[index] = parseInt(e.target.value);
                        setPersonalities(newPersonalities);
                      }}
                      className="personality-slider"
                    />
                  </div>
                ))}
              </div>

              <button className="primary-button" onClick={handleNext}>
                Continue
              </button>
            </div>
          </div>
        )}

        {/* Page 4: Goals */}
        {currentStep === 4 && (
          <div className="step-container fade-in with-bg-avatar">
            <div className="content-overlay scrollable">
              <h2 className="step-title">Choose your goal</h2>
              
              <div className="goals-grid">
                {GOALS.map((goal, index) => (
                  <div 
                    key={index}
                    className={`goal-box ${selectedGoals.includes(goal) ? 'selected' : ''}`}
                    onClick={() => toggleGoal(goal)}
                  >
                    {goal}
                  </div>
                ))}
              </div>

              <button className="primary-button" onClick={handleNext}>
                Continue
              </button>
            </div>
          </div>
        )}

        {/* Page 5: Passions */}
        {currentStep === 5 && (
          <div className="step-container fade-in with-bg-avatar">
            <div className="content-overlay scrollable">
              <h2 className="step-title">Choose your passion</h2>
              
              <div className="passions-grid">
                {PASSIONS.map((passion, index) => (
                  <div 
                    key={index}
                    className={`passion-box ${selectedPassions.includes(passion.text) ? 'selected' : ''}`}
                    onClick={() => togglePassion(passion.text)}
                  >
                    <span className="passion-emoji">{passion.emoji}</span>
                    <span className="passion-text">{passion.text}</span>
                  </div>
                ))}
              </div>

              <button className="primary-button" onClick={handleNext}>
                Continue
              </button>
            </div>
          </div>
        )}

        {/* Page 6: Loading */}
        {currentStep === 6 && (
          <div className="step-container fade-in with-bg-avatar">
            <div className="content-overlay">
              <h2 className="step-title loading-title">Summarizing your data…</h2>
              
              <div className="loader">
                <div className="loader-bar"></div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default OnboardingWizard;